import { useEffect } from 'react'
import { selectPersonalContactSubscriptionData } from '../../SubscriptionForm/SubscriptionFormSelectors'
import { useDispatch, useSelector } from 'react-redux'
import { SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'
import { mapSingleAddressData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Address/mapSingleAddress'
import { mapContactSubscriptionData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contact/mapContactSubscriptionData'
import {
  importContractFromZohoData,
  updateConfig,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { useSnackbarNotification } from '@/shared/tools/notifications/useSnackbarNotification'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react'

const useZohoEventListener = () => {
  const { zohoId } = useSelector(selectPersonalContactSubscriptionData)
  const dispatch = useDispatch()
  const showNotification = useSnackbarNotification()
  const { t } = useTranslation()

  useEffect(() => {
    if (!zohoId) {
      return
    }
    window.Echo.channel(`contacts.imported-from-zoho.${zohoId}`)
      .listen('.operation.success', e => {
        const updatedData = {
          contact: mapContactSubscriptionData(e.data.contact),
          addresses: e.data.addresses?.length > 0 ? e.data.addresses.map(address => mapSingleAddressData(address)) : [],
        }
        dispatch(importContractFromZohoData(updatedData))
        showNotification({
          type: SNACKBAR_TYPES.SUCCESS,
          message: t('common:notifications.contact_imported_successfully'),
        })
        dispatch(updateConfig({ isImportingContactFromZoho: false }))
      })
      .listen('.operation.failed', e => {
        if (import.meta.env.PROD) {
          Sentry.captureException(new Error('Broadcast error importing contact from Zoho'), { extra: { context: 'ZohoImportEcho', eventData: e } })
        }
        showNotification({
          type: SNACKBAR_TYPES.ERROR,
          message: t('common:notifications.cant_import_contact_from_zoho'),
        })
        dispatch(updateConfig({ isImportingContactFromZoho: false }))
      })
  }, [zohoId])
}

export default useZohoEventListener
